import { marketLabel } from '../../lib/protocol';
import { leagueTitle } from '../../lib/sports';
import { useSettings } from '../../store/settings';
import { moneyAmount, profitText, useShow } from '../show';
import { betOn } from '../pick';
import { venueName } from '../meta';
import type { Meta } from '../meta';
import { legOrder, legsFirstOf } from '../order';
import { useProfile } from '../profile';
import { marksOf } from '../Row';
import type { FeedRow } from '../rows';
import { lifePhrase } from '../still';
import { phoneEnter } from './phoneEnter';
import { copyPhoneStart } from './clipboard';
import { bumpCopy } from './haptic';
import { usePhoneQueue } from './queue';

export function PhoneRow({
  row,
  meta,
  held,
  onOpen,
}: {
  row: FeedRow;
  meta: Meta;
  held?: boolean;
  onOpen: (id: string) => void;
}): React.ReactElement {
  const first = legsFirstOf(useProfile((s) => s.profile?.legsFirst));
  const legs = legOrder(row.row.legs, first);
  const unit = useShow((s) => s.unit);
  const fx = useSettings((s) => s.fx);
  const gain = profitText(row.row.profit, row.row.roiPct, fx, unit);
  const marks = marksOf(row);
  const ghost = row.ghost !== null;
  const fork = row.row.fork;
  const what = legs.map((leg) => betOn(leg, fork));

  return (
    <article
      className={`ph-card${held ? ' held' : ''}${ghost ? ' ghost' : ''}`}
      data-fork-row=""
      data-id={row.id}
    >
      <button type="button" className="ph-card__hit" onClick={() => onOpen(row.id)}>
        <span className="ph-card__gain">{gain}</span>
        <span className="ph-card__match">{row.row.fork.league ? leagueTitle(fork) : ''} {marketLabel(fork.market, fork.sport)}</span>
        <span className="ph-card__life">{lifePhrase(row.age, fork, undefined, row.lifespan)}</span>
        {marks.slice(0, 2).map((mark) => (
          <em key={mark.text} className={mark.weight}>{mark.text}</em>
        ))}
      </button>
      <ol className="ph-card__legs">
        {legs.map((leg, i) => (
          <li key={`${leg.source}-${i}`}>
            <button
              type="button"
              className="ph-leg"
              onClick={() => {
                void copyPhoneStart(moneyAmount(leg, fx, meta)).then((ok) => {
                  if (ok) {
                    bumpCopy();
                    usePhoneQueue.getState().say(`в буфере ${moneyAmount(leg, fx, meta)}`);
                  }
                });
                phoneEnter(row, (i + 1) as 1 | 2 | 3);
              }}
            >
              <b>{venueName(meta, leg.source)}</b>
              <span>{what[i]}</span>
              <strong>{moneyAmount(leg, fx, meta)}</strong>
              <i>{String(leg.odds)}</i>
            </button>
          </li>
        ))}
      </ol>
    </article>
  );
}
